import { render, staticRenderFns } from "./EmbedHeader.vue?vue&type=template&id=1c855445&scoped=true&"
import script from "./EmbedHeader.vue?vue&type=script&lang=js&"
export * from "./EmbedHeader.vue?vue&type=script&lang=js&"
import style0 from "./EmbedHeader.vue?vue&type=style&index=0&id=1c855445&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c855445",
  null
  
)

export default component.exports